import { proxy } from 'comlink';
import { loader } from '../common';

const errorMessage = () => {
  document.getElementById('bad-email')?.remove();

  let elem = document.createElement('p');
  elem.setAttribute('id', 'bad-email');
  elem.innerText = 'Invalid email address. Please re-enter.';
  elem.classList.add('error');
  elem.style.textAlign = 'center';
  elem.style.color = '#FFF';
  elem.style.fontSize = '20px';
  elem.style.margin = '1em auto';
  return elem;
};

export default class Controller {
  constructor(props) {
    /*
     ** [continueBtn, processor, creative]
     */
    Object.assign(this, props);
  }

  get active() {
    return window.sooper_panel.panels[this.getActivePanelArrIndex()] ?? false;
  }

  previous(i) {
    const index = i ?? this.getActivePanelArrIndex(),
      panel = window.sooper_panel.panels[index + 1];

    loader({
      status: 'visible',
      panel: this.active.elem,
      continueBtn: this.continueBtn,
    });
    panel.toggle();
    this.next().toggle();
    const active = this.active;
    active.error();
    active.field.value = '';
    active.elem.insertBefore(errorMessage(), active.field.parentElement);
  }

  next(i) {
    const index = i ?? this.getActivePanelArrIndex();

    if (
      index === false ||
      window.sooper_panel.panels.length - 1 === index ||
      window.sooper_panel.panels[index + 1] === undefined
    ) {
      return false;
    }

    const panel = window.sooper_panel.panels[index + 1];

    if (panel?.optional) {
      this.processor.report(panel);
      return this.next(index + 1);
    }

    return panel;
  }

  toggle(curr, next) {
    this.processor.report(curr);
    return curr.toggle(() => {
      next?.toggle();

      const prevCreative = this.creative[curr.name],
        nextCreative = this.creative[next.name];

      if (prevCreative?.afterSubmit) {
        prevCreative?.afterSubmit(curr.value);
      }

      if (nextCreative?.beforeSubmit) {
        nextCreative?.beforeSubmit();
      }

      if (nextCreative?.title) {
        this.label.innerHTML =
          next.elem?.getAttribute('label') ?? nextCreative.title;
        // this.label.setAttribute('data-title', this.label.innerHTML);
      }
      loader({
        status: 'visible',
        panel: this.active.elem,
        continueBtn: this.continueBtn,
      });
    });
  }

  getActivePanelArrIndex() {
    return window.sooper_panel.panels.findIndex((p) => p.active);
  }

  getPanelByFieldName(name) {
    const panels = window.sooper_panel.panels;

    for (let panel of panels) {
      if (panel.name !== name) {
        continue;
      }

      return panel;
    }

    return false;
  }

  async submit(cb) {
    const { active } = this,
      next = this.next();

    // failed validation
    // console.log(`Active Validate: ${active.validate()}`);

    if (!active.validate()) {
      active.error();
      loader({
        status: 'visible',
        panel: this.active.elem,
        continueBtn: this.continueBtn,
      });
      return (this.continueBtn.disabled = false);
    }

    // no action present
    if (active?.action === false) {
      this.toggle(active, next);
      return (this.continueBtn.disabled = false);
    }

    // trigger action
    return cb(await this.processor.exec(active));
  }
}
